import { JSX } from 'solid-js';
import clsx from 'clsx';

export type BadgeVariant = 'highlight' | 'status-success' | 'status-highlight' | 'status-neutral';

type BadgeProps = {
    variant?: BadgeVariant;
    class?: string;
    children: JSX.Element;
};

/* DS `ds-badge` variant → surface. Signal variants carry inverse text, status variants fg-default. */
const VARIANT_CLASSES: Record<BadgeVariant, string> = {
    'highlight': 'bg-cvi-bg-interactive-strong text-cvi-fg-on-color',
    'status-success': 'bg-cvi-bg-status-success text-cvi-fg-default',
    'status-highlight': 'bg-cvi-bg-status-highlight text-cvi-fg-default',
    'status-neutral': 'bg-cvi-bg-block-neutral-strong text-cvi-fg-default',
};

/**
 * DS badge (Storybook `components-badge`). Inline pill: body-sm medium on a
 * 4px-radius surface, 4px/8px padding. The DS trims the text box with
 * `text-box-trim`; `leading-none` gives the same 24px geometry everywhere.
 */
export const Badge = (props: BadgeProps) => (
    <span
        class={clsx(
            'inline-block rounded-cvi-sm px-cvi-4 py-cvi-2 body-sm font-cvi-medium leading-none whitespace-nowrap',
            VARIANT_CLASSES[props.variant ?? 'highlight'],
            props.class,
        )}
    >
        {props.children}
    </span>
);
